/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CustomDetailDataTypeEnum {
    STRING = 'STRING',
    NUMBER = 'NUMBER',
    BOOLEAN = 'BOOLEAN',
    BANK_ACCOUNT = 'BANK_ACCOUNT',
    TAX_RESIDENCY = 'TAX_RESIDENCY',
    TIN = 'TIN',
    COUNTRY_OF_BIRTH = 'COUNTRY_OF_BIRTH',
    FORM = 'FORM',
    PRE_FILLABLE_FORM = 'PRE_FILLABLE_FORM',
}
